if(!customElements.get('custom-select')){
    class CustomSelect extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            // button
            this.buttonSelect = this.querySelector('button');
            if(!this.buttonSelect) return;
            this.boundToggle = this.toggleOptions.bind(this);
            this.buttonSelect.addEventListener('click', this.boundToggle);
            this.boundCloseOutside = this.closeOnClickOutsideOptions.bind(this);
            document.addEventListener("pointerdown", this.boundCloseOutside);

            this.listOptionsWrapper = this.querySelector('ul');
            if(!this.listOptionsWrapper) return;

            // select
            this.select = this.querySelector('select');
            if(!this.select) return;
            const selectedOption = this.select.value;
            this.selectOptions = this.select.querySelectorAll('option');
            this.selectOptions.forEach(item => {
                const newElem = document.createElement('li');
                newElem.classList.add('transition-all', 'duration-300', 'ease-in-out');
                newElem.innerHTML = item.innerHTML;
                newElem.setAttribute('data-value', `${item.value}`);
                newElem.setAttribute('tabindex', '0');

                if(item.value === selectedOption){
                    this.buttonSelect.querySelector('span').innerHTML = `${item.innerText}`;
                }

                this.listOptionsWrapper.appendChild(newElem);
            });

            // custom list options
            this.listOptions = this.listOptionsWrapper.querySelectorAll('li');
            this.listOptions.forEach(item => {
                item.addEventListener('click', this.clickOnOption.bind(this));
                item.addEventListener("keydown", this.keydownOnOption.bind(this));
            });
        }

        disconnectedCallback(){
            if(this.boundCloseOutside){
                document.removeEventListener("pointerdown", this.boundCloseOutside);
            }
        }

        toggleOptions(e){
            e.stopPropagation();

            if(this.listOptionsWrapper.getAttribute('data-hidden') === 'true'){
                this.openOptions();
            }else{
                this.closeOptions();
            }
        }

        closeOnClickOutsideOptions(e){
            if(this.listOptionsWrapper.getAttribute('data-hidden') === 'true') return;
            const clickedItem = e.target;

            if(clickedItem.closest('custom-select') !== this) {
                this.closeOptions();
            }
        }

        keydownOnButton(e){
            if(!this.listOptionsWrapper) return;

            if(e.key === 'ArrowDown' || e.key === 'Tab'){
                const focusableElements = this.selectOptions;
                const nextIndex = 0;
                focusableElements[nextIndex].focus();
            }else if(e.key === 'Escape'){
                this.closeOptions();
            }
        }

        openOptions(){
            this.listOptionsWrapper.setAttribute('data-hidden', 'false');
            this.listOptionsWrapper.removeAttribute('inert');
            this.buttonSelect.addEventListener("keydown", this.keydownOnButton.bind(this));
        }

        closeOptions(){
            this.listOptionsWrapper.setAttribute('data-hidden', 'true');
            this.listOptionsWrapper.setAttribute('inert', '');
            this.buttonSelect.removeEventListener("keydown", this.keydownOnButton.bind(this));
        }

        clickOnOption(e){
            const option = e.currentTarget;
            const optionValue = option.dataset.value;
            if(!optionValue) return;

            this.select.value = optionValue;
            this.select.dispatchEvent(new Event('change'));
            
            const optionText = this.select.options[this.select.selectedIndex].text;
            this.buttonSelect.querySelector('span').innerHTML = `${optionText}`;

            this.closeOptions();
        }

        keydownOnOption(e){
            if(e.key === 'ArrowDown'){
                e.preventDefault();
                const focusableElements = this.listOptionsWrapper.querySelectorAll('li');
                const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                const nextIndex = currentIndex === focusableElements.length - 1? currentIndex : currentIndex + 1;
                focusableElements[nextIndex].focus();
            }else if(e.key === 'ArrowUp'){
                e.preventDefault();
                const focusableElements = this.listOptionsWrapper.querySelectorAll('li');
                const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                const nextIndex = currentIndex === 0? 0 : currentIndex - 1;
                focusableElements[nextIndex].focus();
            }else if(e.key === 'Escape'){
                this.closeOptions();
            }else if(e.key === 'Tab'){
                const focusableElements = this.listOptionsWrapper.querySelectorAll('li');
                const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                const nextIndex = currentIndex + 1;
                if(!focusableElements[nextIndex]){
                    this.closeOptions();
                }
            }else if(e.key === 'Enter'){
                this.clickOnOption(e);
            }
        }
    }

    customElements.define('custom-select', CustomSelect);
}